import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Box, Link } from "@mui/material";
import color from "../../../Constants/colors";
import { useDashboardColors } from "../../HomePage/dashboardColors";
import { DocumentCraftingDocumentListItem } from "../../../Models/documentCrafting";
import LabelChips from "../Common/LabelChips";
import {
  DocumentOwner,
  DocumentStatus,
  DocumentThumbnail,
  DocumentTypeLine,
  LatestRevision,
  documentTarget,
  isInteractiveTarget,
} from "./DocumentListParts";

/** The documents as stacked cards on narrow screens (below md). */
const DocumentCards: React.FC<{ documents: DocumentCraftingDocumentListItem[] }> = ({
  documents,
}) => {
  const navigate = useNavigate();
  const { primary } = useDashboardColors();

  return (
    <Box component="ul" sx={{ listStyle: "none", m: 0, p: 0 }}>
      {documents.map((item) => {
        const target = documentTarget(item);
        return (
          <Box
            component="li"
            key={item.id}
            onClick={(event: React.MouseEvent) => {
              if (!isInteractiveTarget(event.target)) navigate(target);
            }}
            sx={{
              display: "grid",
              gridTemplateColumns: "64px minmax(0, 1fr)",
              gap: 1.5,
              py: 1.5,
              cursor: "pointer",
              borderBottom: `1px solid ${color.gray100}`,
              "&:last-of-type": { borderBottom: "none" },
            }}
          >
            <DocumentThumbnail item={item} width={64} />
            <Box
              sx={{
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                gap: 0.75,
              }}
            >
              <Link
                component={RouterLink}
                to={target}
                underline="hover"
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: primary,
                  overflowWrap: "anywhere",
                }}
              >
                {item.title}
              </Link>
              <DocumentTypeLine item={item} />
              <LabelChips
                projectLabels={item.project_labels}
                personalLabels={item.personal_labels}
                max={3}
              />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "minmax(0, 1fr)",
                    sm: "minmax(0, 1fr) minmax(0, 1fr)",
                  },
                  gap: 1,
                }}
              >
                <DocumentOwner item={item} />
                <LatestRevision item={item} />
              </Box>
              <DocumentStatus item={item} direction="row" />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default DocumentCards;
